<template>
  <form>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon1">Produits commandés</span>
      </div>
      <textarea type="text" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2"></textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-append">
        <span class="input-group-text" id="basic-addon2">Acheteur Potentiel</span>
      </div>
      <input type="text" class="form-control" placeholder="Adresse email" aria-label="Email" aria-describedby="basic-addon2">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Date et Temps de commande</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
      <input type="text" aria-label="Last name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Notes</span>
      </div>
      <textarea type="text" aria-label="First name" class="form-control"></textarea>
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Quantité/produit</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Prix unitaire/produit</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Prix total</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Promotions/produit</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Montant à payer</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">date et temps de mise à jour</span>
      </div>
      <input type="text" aria-label="First name" class="form-control">
      <input type="text" aria-label="First name" class="form-control">
    </div>
    <div class="input-group-sm input-group mb-3">
      <div class="input-group-prepend">
        <span class="input-group-text">Adresse de livrason</span>
      </div>
      <input type="date" aria-label="First name" class="form-control">
    </div>
  </form>
</template>

<script>
export default {
  name: "Update"
}
</script>

<style lang="scss" scoped>
form{
  & > div{
    & > div{
      & > span, & > label{
        background-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
        color: var(--color-white, rgba(255, 255, 255, 1));
        border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
      }
      & > span.customized-span{
        padding: 0.25rem 0.5rem;
        font-size: 0.875rem;
        line-height: 1.5;
        border-radius: 0.2rem;
      }
    }
    & > input, & > select{
      border-color: var(--color-curious-blue, rgba(34, 134, 195, 1));
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/commandes_encours/components/Update.vue